import sourceMessages from './resources/messages.json';
import { DEFAULT_LOCALE_UNDERSCORE, getFinalLocale } from '../src/lib/localeInfo';

type LocaleMessages = Record<string, string>;

function normalizeToUnderscoreLocale(locale?: string): string {
  return getFinalLocale(locale).replace('-', '_');
}

export function formatLocale(locale?: string): string {
  return normalizeToUnderscoreLocale(locale).replace('_', '-');
}

export async function getLocaleMessages(locale?: string): Promise<LocaleMessages> {
  const normalizedLocale = normalizeToUnderscoreLocale(locale);

  try {
    const localeMessages = await import(`./translations/${normalizedLocale}.json`);
    return {
      ...(sourceMessages as LocaleMessages),
      ...(localeMessages.default as LocaleMessages),
    };
  } catch {
    const fallbackMessages = await import(`./translations/${DEFAULT_LOCALE_UNDERSCORE}.json`);
    return fallbackMessages.default as LocaleMessages;
  }
}
